import SysDataTableExpand from "@/components/utils/dataTable/sysDataTableExpand/Index";
import FiltroPeriodoAnalise from '@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/Filtros/FiltroPeriodoAnalise.vue';
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import DetalhamentoDuploClique from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/DetalhamentoDuploClique/Index";
import SysStatusProduto from "@/components/utils/crud/SysStatusProduto.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";
import SysProdutoAutocomplete from "@/components/utils/crud/SysProdutoAutocomplete";
import HistoricoMovimentacao from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/HistoricoMovimentacao/Index.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";

export const componentes = {
  SysDataTableExpand,
  FiltroPeriodoAnalise,
  FiltrosUniversalAvancado,
  DetalhesProduto,
  DetalhamentoDuploClique,
  SysStatusProduto,
  HistoricoMovimentacao,
  SysAutocomplete,
  TextoOutrosFiltrosSelecionadosAutocomplete,
  SysProdutoAutocomplete,
}
